export default "__VITE_ASSET__f5ZvfW7j__"